import { createSlice } from "@reduxjs/toolkit";

export type TGlobalState = {
  selectedChain: {
    name?: string;
    id?: number;
  };
  unwrapTxnState: {
    success: boolean;
  };
};

export const initialState: TGlobalState = {
  selectedChain: {
    id: undefined,
    name: undefined,
  },
  unwrapTxnState: {
    success: false,
  },
};

export const globalSlice = createSlice({
  name: "global",
  initialState: initialState,
  reducers: {
    updateSelectedChain: (state, action) => {
      state.selectedChain = action.payload;
    },
    updateUnwrapTxnState: (state, action) => {
      state.unwrapTxnState = action.payload;
    },
  },
});

export const { updateSelectedChain, updateUnwrapTxnState }: any =
  globalSlice.actions;

export default globalSlice.reducer;
